<template>
  <span>
    <slot
      :disabled="isButtonDisabled"
      :isFavorite="isFavorite"
      :onClick="onClick"
    />
  </span>
</template>

<script>
import catchDispatch from "@/utils/catchDispatch";

export default {
  props: {
    entityId: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      entityType: 'chat',
      submit: false,
    };
  },
  computed: {
    favorite: {
      get() {
        const list = this.$store.state.favorite.list;
        return list[this.entityId];
      },
      set(favorite) {
        this.$store.commit('favorite/SET_LIST', {entity_id: this.entityId, favorite});
      },
    },
    isButtonDisabled() {
      return !this.entityId.length || this.submit || this.loading;
    },
    isFavorite() {
      try {
        return this.favorite.value === 'true';
      } catch (e) {
        return false;
      }
    },
  },
  watch: {
    entityId(entityId) {
      this.fetch(entityId);
    },
  },
  created() {
    this.fetch(this.entityId);
  },
  methods: {
    onClick() {
      this.setFavorite(!this.isFavorite);
    },
    fetch(entity_id) {
      if (!entity_id.length) {
        this.favorite = {};
        return;
      }
      if (this.loading) return;

      this.loading = true;
      this.$store
        .dispatch('favorite/check', {entity_id})
        .finally(() => this.loading = false);
    },
    setFavorite(is) {
      this.submit = true;
      this.$store
        .dispatch('favorite/set', {
          ...this.favorite,
          entity_id: this.entityId,
          entity_type: this.entityType,
          is,
        })
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.submit = false);
    },
  },
}
</script>

<style scoped>

</style>
